import React from 'react';

/**
 * Reusable folder upload form component for folder portals
 * @param {Object} props
 * @param {string} props.folderId - The ID of the folder to upload to
 * @param {string} props.folderName - The name of the folder to upload to
 * @param {Function} props.onFileSelection - Handler for file selection
 * @param {Function} props.onUpload - Handler for upload action
 * @param {Function} props.onCancel - Handler for cancel action
 * @param {Array} props.selectedFiles - Array of selected files
 * @param {string} props.uploadProgress - Current upload progress message
 * @param {number} props.level - Nesting level for proper indentation
 */
const FolderUploadForm = ({ 
  folderId, 
  folderName, 
  onFileSelection, 
  onUpload, 
  onCancel, 
  selectedFiles = [], 
  uploadProgress,
  level = 0 
}) => {
  return (
    <div style={{
      marginLeft: `${(level + 1) * 20}px`,
      backgroundColor: 'rgba(76, 175, 80, 0.2)',
      padding: '12px',
      borderRadius: '6px',
      margin: '8px 0'
    }}>
      <div style={{ marginBottom: '10px', color: 'white', fontWeight: 'bold' }}>
        Upload files to: {folderName}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <input
          type="file"
          multiple
          accept=".pdf, .ppt, .pptx, .doc, .docx, .xls, .xlsx, .csv, .txt, .jpg, .jpeg, .png"
          onChange={onFileSelection}
          style={{
            padding: '6px',
            borderRadius: '4px',
            border: '1px solid #ccc',
            backgroundColor: 'white'
          }}
        />
        {selectedFiles.length > 0 && (
          <div style={{ color: 'white', fontSize: '0.9em' }}>
            Selected: {selectedFiles.map(f => f.name).join(', ')}
          </div>
        )}
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <button 
            onClick={() => onUpload(folderId, selectedFiles)}
            disabled={selectedFiles.length === 0 || uploadProgress === 'Uploading...'}
            style={{
              background: selectedFiles.length > 0 ? '#4CAF50' : '#999',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '6px 12px',
              cursor: selectedFiles.length > 0 ? 'pointer' : 'not-allowed'
            }}
          >
            Upload
          </button>
          <button 
            onClick={onCancel}
            style={{
              background: '#f44336',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              padding: '6px 12px',
              cursor: 'pointer'
            }}
          >
            Cancel
          </button>
          {uploadProgress && (
            <span style={{ 
              color: uploadProgress.includes('successful') ? '#4CAF50' : 
                     uploadProgress.includes('Error') || uploadProgress.includes('Access denied') ? '#f44336' : 'white',
              fontSize: '0.9em',
              fontWeight: 'bold'
            }}>
              {uploadProgress}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default FolderUploadForm;